<template>
  <div>
    <div class="alertBox1">
      <dialogWrap
        v-model="handelDialogVisible"
        :title="title"
        :width="'824px'"
        :before-close="closePolicy"
        destroy-on-close
      >
        <el-form
          label-position="right"
          :model="formLabelAlign"
          ref="formPolicy"
          :rules="rules"
          class="addPolicy"
          label-width="110px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="车牌号:" prop="carId">
                <CarSelect
                  :modelValue="formLabelAlign.carId"
                  :getCarDetail="true"
                  :plateNo="formLabelAlign.plateNo"
                  :disabled="plateNoDisabled"
                  @update:modelValue="val => { formLabelAlign.carId = val }"
                  @change="carChange"></CarSelect>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="品牌:" prop="brandName">
                <div>{{ formLabelAlign.brandName || '--' }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车系:" prop="seriesName">
                <div>{{ formLabelAlign.seriesName || '--' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="车型:" prop="carModelName">
                <div>{{ formLabelAlign.carModelName || '--' }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车辆ID:">
                <div>{{ formLabelAlign.carId || '--' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保险类型:" prop="type">
                <el-select
                  placeholder="请选择"
                  v-model="formLabelAlign.type"
                  clearable
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="保单号:" prop="policyNo">
                <span v-if="this.type !== 'add'">{{ formLabelAlign.policyNo }}</span>
                <el-input
                  v-else
                  v-model="formLabelAlign.policyNo"
                  placeholder="请输入"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="保费:" prop="premium">
                <el-input
                  v-model="formLabelAlign.premium"
                  placeholder="请输入"
                  v-limit-money="true"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="保险公司:" prop="providerName">
                <el-select
                  placeholder="请选择"
                  v-model="formLabelAlign.providerName"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item,index) in options2"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开始日期:" prop="startDate">
                <el-date-picker
                  v-model="formLabelAlign.startDate"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                  :picker-options="startTimeLimit"
                  :clearable="true"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="结束日期:" prop="endDate">
                <el-date-picker
                  v-model="formLabelAlign.endDate"
                  type="date"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :clearable="true"
                  :picker-options="endTimeLimit"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 新增的时候不显示 -->
          <el-row v-if="type !== 'add' && formLabelAlign.type === 2">
            <el-col :span="12">
              <el-form-item label="停保时间:" prop="stopDate">
                <el-date-picker
                  v-model="formLabelAlign.stopDate"
                  type="date"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :clearable="true"
                  @change="stopDateChange"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="复保时间:" prop="resumeDate">
                <el-date-picker
                  v-model="formLabelAlign.resumeDate"
                  type="date"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :clearable="true"
                  :picker-options="resumeDateLimit"
                  :disabled="canChooseResumeDate"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注:" class="alone" prop="remarks">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入"
                  v-model="formLabelAlign.remarks"
                  maxlength="500"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="保单附件:" class="alone">
                <UploadCommon
                  listType="text"
                  :fileList="fileList"
                  :limit="20"
                  :sizeType="4"
                  @uploadBefore="uploadBefore"
                  @uploadSuccess="uploadSuccess"
                  @uploadError="uploadError"
                  commonUpload
                  group="assert"
                  code="assert_guarantee_slip"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template slot="footer">
          <el-button @click="closePolicy" size="small">取消</el-button>
          <el-button
            v-if="type === 'add'"
            :loading="oLoading.submit"
            type="primary"
            @click="addPolicy"
            size="small"
          >确认新增</el-button>
          <el-button
            v-else
            :loading="oLoading.submit"
            type="primary"
            @click="confirmEdit"
            size="small"
          >确认编辑</el-button>
        </template>
      </dialogWrap>
    </div>
  </div>
</template>
<script>
import { policyEdit, policyAdd } from '@/api/serviceAPi'
import selectOption from '@/store/dict/selectOptionDict'
import { getInsuranceCompanyListV2 } from '@/api/domain/cars'
import moment from 'moment'

export default {
  props: {
    // 操作方式 add,edit
    type: {
      type: String,
      default: 'add',
    },
    editFileList: {
      type: Array,
      default: () => [],
    },
    editData: {
      type: Object,
      default: () => ({
        plateNo: '',
        brandName: '',
        seriesName: '',
        carModelName: '',
        id: '',
        carId: '',
        type: '',
        policyNo: '',
        premium: '',
        providerName: '',
        startDate: '',
        endDate: '',
        remarks: '',
        attachment: '',
      }),
    },
    plateNo: {
      type: String,
      default: '',
    },
    // 车牌号禁选-场景：车辆详情页中新增保单禁止更改车牌号
    plateNoDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      handelDialogVisible: false, // 新增保单弹框的显隐
      rules: {
        carId: [
          { required: true, message: '车牌号不能为空', trigger: 'change' },
        ],
        type: [
          { required: true, message: '保险类型不能为空', trigger: 'change' },
        ],
        policyNo: [
          { required: true, message: '保单号不能为空', trigger: 'blur' },
          { min: 2, max: 64, message: '长度在 2 到 64 个字符', trigger: 'blur' },
        ],
        premium: [{ required: true, message: '保费不能为空', trigger: 'blur' }],
        providerName: [
          { required: true, message: '保险公司不能为空', trigger: 'change' },
        ],
        startDate: [
          { required: true, message: '开始时间不能为空', trigger: 'blur' },
        ],
        endDate: [
          { required: true, message: '结束时间不能为空', trigger: 'blur' },
        ],
      },
      oLoading: {
        submit: false,
      },
      fileList: [],
      // 弹框表单的数据
      formLabelAlign: {
        plateNo: '',
        carModelName: '',
        id: '',
        carId: '',
        type: '',
        policyNo: '',
        premium: '',
        providerName: '',
        startDate: '',
        endDate: '',
        remarks: '',
        attachment: '',
        stopDate: '',
        resumeDate: '',
      },
      options2: [], // 保险公司列表
    }
  },
  watch: {
    handelDialogVisible(val) {
      if (val && this.plateNo) {
        this.formLabelAlign.plateNo = this.plateNo
      }
      if (val) {
        this.getProvider()
      }
    },
  },
  computed: {
    // 保险类型
    options() {
      return this.dictParseList(selectOption.insuranceTypeDict)
    },
    title() {
      return this.type === 'add' ? '新增保单' : '编辑保单'
    },
    // 开始时间
    startTimeLimit() {
      return {
        disabledDate: (time) => {
          const endTime = this.formLabelAlign.endDate
          const endDateTime = moment(endTime)
            .startOf('day')
            .format('x')
          if (endDateTime) {
            return time >= endDateTime
          }
        },
      }
    },
    // 结束时间
    endTimeLimit() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const startTime = this.formLabelAlign.startDate
          if (startTime) {
            return time < new Date(startTime).getTime()
          }
        },
      }
    },
    // 是否可以选择复保时间
    canChooseResumeDate() {
      const { stopDate } = this.formLabelAlign
      return !stopDate
    },
    // 复保时间
    resumeDateLimit() {
      return {
        disabledDate: (time) => {
          time = time.getTime()
          const { stopDate } = this.formLabelAlign
          if (stopDate) {
            // 结束时间0点的时间戳
            const stopDateTime = moment(stopDate)
              .startOf('day')
              .format('x')
            return time <= stopDateTime
          }
        },
      }
    },
  },
  methods: {
    stopDateChange() {
      this.formLabelAlign.resumeDate && (this.formLabelAlign.resumeDate = '')
    },
    uploadBefore() {
      this.oLoading.submit = true
    },
    uploadSuccess() {
      this.oLoading.submit = false
    },
    uploadError() {
      this.oLoading.submit = false
    },
    // 设置编辑数据
    // eslint-disable-next-line vue/no-unused-properties
    setEditData() {
      this.fileList = this.getEchoUploadFileData(this.editFileList, true)
      // this.fileList = this.editFileList
      this.formLabelAlign = this.editData
    },
    /* 确定编辑按钮 */
    confirmEdit() {
      this.$refs.formPolicy.validate(async (valid) => {
        if (valid) {
          this.oLoading.submit = true
          const {
            startDate,
            endDate,
            stopDate,
            resumeDate,
          } = this.formLabelAlign
          let params = {
            ...this.formLabelAlign,
            attachment: this.getUoloadCommonFileData(this.fileList, true, 'push'),
          }
          if (this.formLabelAlign.type === 2) {
            params = {
              ...params,
              startDate: `${startDate} 00:00:00`,
              endDate: `${endDate} 00:00:00`,
            }
            if (stopDate) {
              params.stopDate = stopDate.split(' ')[1]
                ? stopDate
                : `${stopDate} 00:00:00`
            } else {
              delete params.stopDate
            }
            if (resumeDate) {
              params.resumeDate = resumeDate.split(' ')[1]
                ? resumeDate
                : `${resumeDate} 00:00:00`
            } else {
              delete params.resumeDate
            }
          }
          try {
            const data = await policyEdit(params)
            this.oLoading.submit = false
            if (data.code === 1) {
              this.$message.success('操作成功')
              this.addShow1 = false
              this.$emit('handelSuccess')
              this.closePolicy()
            }
          } catch (error) {
            this.oLoading.submit = false
          }
        }
      })
    },
    /* 确定新增按钮 */
    addPolicy() {
      this.formLabelAlign.attachment = this.getUoloadCommonFileData(
        this.fileList,
        true,
        'push',
      )
      this.$refs.formPolicy.validate((valid) => {
        if (valid) {
          this.addPolicyFun()
        }
      })
    },
    /* 新增保单接口 */
    async addPolicyFun() {
      this.oLoading.submit = true
      try {
        const data = await policyAdd({
          ...this.formLabelAlign,
        })
        this.oLoading.submit = false
        if (data.code === 1) {
          this.$message.success('操作成功')
          this.closePolicy()
          this.$emit('handelSuccess')
        }
      } catch (error) {
        this.oLoading.submit = false
      }
    },
    /* 获取保险公司 */
    async getProvider() {
      const { code, data } = await getInsuranceCompanyListV2()
      if (code === 1) {
        this.options2 = data
      }
    },
    /* 车牌号改变后发送请求 */
    carChange(id, carInfo) {
      this.formLabelAlign.carModelName = carInfo?.modelName || ''
      this.formLabelAlign.plateNo = carInfo?.plateNo || ''
      this.formLabelAlign.brandName = carInfo?.brandName || ''
      this.formLabelAlign.seriesName = carInfo?.seriesName || ''
    },
    // 关闭弹框
    closePolicy() {
      this.handelDialogVisible = false
      this.$refs.formPolicy.resetFields()
      this.fileList = []
      Object.keys(this.formLabelAlign).forEach((item) => {
        this.formLabelAlign[item] = ''
      })
    },
  },
}
</script>
<style scoped lang="scss">
.addPolicy {
  ::v-deep .el-input--small {
    width: 220px;
  }
}
</style>
